import { submitForm, SubmitFormError } from './submitForm';
import { SubmitFormRequest, SubmitFormResponse, SubmitFuelSavingsCalculatorRequest } from './types';
import { useMutation } from '../../../utils/restApi/useMutation';

export const useSubmitForm = () =>
  useMutation<SubmitFormResponse, SubmitFormError, SubmitFormRequest>({
    mutationFn: submitForm,
  });

export const useSubmitFuelSavingsCalculator = () =>
  useMutation<SubmitFormResponse, SubmitFormError, SubmitFormRequest<SubmitFuelSavingsCalculatorRequest>>({
    mutationFn: submitForm,
  });
